export default class CurrentValueModel {
    idNValor: number | null;
    fkNVariable: number | null;
    fldDFechaSupervisor: Date | null;
    fldDInsert: Date | null;
    fldDInsertUTF: Date | null;
    fldTValor: string | null;

    constructor() {
        this.idNValor = null;
        this.fkNVariable= null;
        this.fldDFechaSupervisor= null;
        this.fldDInsert= null;
        this.fldDInsertUTF = null;
        this.fldTValor= null;
    }
}